export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      '一般、アプリケーション、オブジェクト指向、ネットワーク、および<b>組み込み（embedded）</b>プログラミングにおける<b>Go</b>、<b>Rust</b>、および<b>C/C++</b>の体系的な実践知識。',
      '<b>AI</b>と他のアプリケーション層の統合。<b>機械学習</b>と<b>ディープラーニング</b>分野の実践的な知識。',
      '<b>Vue</b>テクノロジーと<b>TypeScript</b>を使用したデスクトップおよびWebアプリケーションのプログラミング。',
      'データベース管理 - <b>SQLite</b>、<b>MongoDB</b>、および<b>MySQL</b>の経験。<b>Google Cloud</b>などのDevOpsの基礎。',
      '<b>物理プロセスのモデリング</b>や、<b>ML</b>を使用した<b>コンピューターシミュレーション</b>を実行する能力。',
      '<b>モンテカルロ法</b>、<b>分子動力学</b>、<b>DFT</b>などの計算材料工学の手法の知識。',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      '<b>オペレーティングシステム</b>と<b>コンピューターアーキテクチャ</b>の知識。<b>シェル</b>の習熟を含む、<b>Linux / UNIX</b>システムでの作業。',
      'コンピュータネットワークやデータセキュリティなどの分野における<b>テレインフォマティクス</b>の基礎知識。',
      '<b>通信</b>の分野における実践的な知識。インストールの構成とインターネットシステムの作成。',
      'コンピュータおよび測定機器の操作。<b>LabVIEW</b>での<b>測定のコンピュータ化</b>。',
      '<b>電子機器</b>の診断と修理。<b>電子回路図</b>を読む能力。',
      '<b>AVR</b>マイクロコントローラーと組み込みシステム、特に<b>Arduino</b>の操作とプログラミングの基礎。',
      '<b>テクニカル図面</b>を作成および読み取り、<b>NX</b>ソフトウェアで2Dおよび3D回路図を作成する能力。',
      '<b>XRD、DSC、DTA / TGA、TMA、XAS</b>などの高度な材料研究手法、および吸収、発光、インピーダンス、赤外線などの<b>分光法</b>の経験。',
    ],
  },
  science: {
    space: [5],
    list: [
      '<b>先端材料の物理学と化学</b>で使用されるプロセスと技術に関する包括的な知識。',
      '<b>イオンプロセスの物理学</b>、特にエネルギー<b>処理と貯蔵</b>技術における経験。',
      '<b>半導体構造の物理学</b>と<b>固体電子工学</b>の現代的な応用に関する知識。',
      '<b>ナノ構造</b>および<b>低次元システム</b>の製造における理論と技術プロセスに関する実践的な知識。',
      '<b>レーザー物理学</b>、<b>オプトエレクトロニクスとフォトニクス</b>、および<b>原子核物理学</b>の応用の分野における実践的な知識と問題解決。',
      '<b>工学およびプログラミングアプリケーション</b>における高度な<b>高等数学</b>の要素の知識。',
      '<b>ROOT</b>および<b>Python</b>での<b>統計とデータ分析</b>の基礎知識。<b>NumPy</b>、<b>Pandas</b>、および<b>Matplotlib</b>ライブラリの操作。',
      '<b>Mathematica</b>および<b>Python</b>で<b>数値計算</b>および数式計算を実行する基本的な能力。',
    ],
  },
  soft: {
    list: [
      '<b>知識の習得</b>の容易さ。迅速な<b>学習</b>、<b>柔軟性</b>、および変化への<b>適応</b>。',
      '<b>プロジェクト管理</b>および<b>チームワーク</b>の能力。リーダーおよびチームメンバーとしての経験。',
      '優れた<b>コミュニケーションスキル</b>と組織力。人との<b>交流におけるオープンさ</b>。',
      '科学会議への参加によって裏付けられた、<b>英語</b>での専門的なコミュニケーションの経験。',
      '<b>論理的、創造的、批判的思考</b>の能力。',
    ],
  },
}
